import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalsService as GlobalsServiceOld } from '@services/globals.service';
import { GlobalsService } from '@app/services/micro/globals.service';
import { MessagesService } from "@services/messages.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FlightDetailModalComponent } from "@modals/flight-detail-modal/flight-detail-modal.component";
import { LookUpPnrService } from '@app/services/micro/lookup-pnr.service';


@Component({
    selector: 'app-stepper-bags',
    templateUrl: './stepper-bags.component.html',
    styleUrls: ['./stepper-bags.component.scss'],
    standalone: false
})
export class StepperBagsComponent implements OnInit {

  @Input() step: number = 0;
  // @Input() isrb: boolean = false;
  valid: boolean = true;
  valid2: boolean = false;
  valid3: boolean = false;
  status=0
  constructor() { }

  ngOnInit(): void {
    console.log(this.step , ' *********************************** stepppp'  )

  }

}
